import $ from 'jquery';

// Masonry
if ($('.js--masonry').length) {
    var waypoint = new Waypoint({
	  	element: document.querySelector('.js--masonry'),
	  	handler: function() {
	    	$('.site-header').toggleClass('site-header--box-shadow');
	  	}
	})
}

// Circles
function circles($this) {
	var $that = $this;
	$('.js--dimension-link').each(function() {
		$(this).removeClass('active');
	});
	$that.addClass('active');
	$('.js--dimension').each(function() {
		$(this).hide();
		if( $(this).hasClass('active') ) {
			$(this).removeClass('active');
		}
		if( $that.data('dimensions') == $(this).data('dimensions') ) {
			$(this).toggle();
			$('.js--dimension-image').attr('src', $that.data('dimension-image'));
			$('.js--dimension-image').attr('alt', $that.data('dimensions'));
		}
	});
}
if($('.js--dimension-link').length) {
	$('.js--dimension-link').on('mouseover', function() {
		circles($(this));
	})
}
